import React, { useEffect, useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import api from '@/lib/api';
import { Card } from '@/components/ui/card';

export const PartnerStockPage = () => {
  const { t } = useLanguage();
  const [stock, setStock] = useState([]);
  const [pharmacies, setPharmacies] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const [prods, pharms] = await Promise.all([
        api.get('/products'),
        api.get('/pharmacies')
      ]);
      setProducts(prods.data);
      setPharmacies(pharms.data);
      
      const stockData = [];
      for (const ph of pharms.data) {
        const s = await api.get(`/stock-ledger?pharmacy_id=${ph.id}`);
        for (const item of s.data) {
          if (prods.data.some(p => p.id === item.product_id)) {
            stockData.push({ ...item, pharmacy_name: ph.name });
          }
        }
      }
      setStock(stockData);
    } catch (e) {
      console.error(e);
    }
  };

  const getExpiryColor = (m, y) => {
    const now = new Date();
    const expiry = new Date(y, m - 1);
    const monthsDiff = (expiry.getFullYear() - now.getFullYear()) * 12 + (expiry.getMonth() - now.getMonth());
    if (monthsDiff <= 3) return 'bg-red-50 text-red-700 border-red-200';
    if (monthsDiff <= 6) return 'bg-orange-50 text-orange-700 border-orange-200';
    if (monthsDiff <= 9) return 'bg-yellow-50 text-yellow-700 border-yellow-200';
    if (monthsDiff <= 12) return 'bg-blue-50 text-blue-700 border-blue-200';
    return 'bg-gray-50 text-gray-700 border-gray-200';
  };

  return (
    <div className="min-h-screen p-4" style={{ backgroundColor: '#F8FAFC', fontFamily: 'IBM Plex Sans' }}>
      <h1 className="text-3xl font-bold mb-6" style={{ fontFamily: 'Manrope', color: '#1E3A8A' }}>{t('nav.whereStock')}</h1>

      <Card className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-100">
            <tr>
              <th className="text-left p-3">Pharmacy</th>
              <th className="text-left p-3">Product</th>
              <th className="text-left p-3">Batch</th>
              <th className="text-left p-3">Expiry</th>
              <th className="text-right p-3">Quantity</th>
            </tr>
          </thead>
          <tbody>
            {stock.map((item, idx) => (
              <tr key={idx} className="border-t border-slate-200">
                <td className="p-3">{item.pharmacy_name}</td>
                <td className="p-3 font-medium">{item.product_name}</td>
                <td className="p-3 text-slate-600">{item.batch_number}</td>
                <td className="p-3">
                  <span className={`px-2 py-1 rounded-full text-xs font-semibold border ${getExpiryColor(item.expiry_month, item.expiry_year)}`}>
                    {String(item.expiry_month).padStart(2, '0')}/{item.expiry_year}
                  </span>
                </td>
                <td className="p-3 text-right font-bold">{item.quantity}</td>
              </tr>
            ))}
            {stock.length === 0 && (
              <tr><td colSpan="5" className="p-6 text-center text-slate-500">{t('common.noData')}</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
};
